import { Box } from "@mui/material";
import SaveAgendaResponseForm from "../../organisms/project/project-agenda/project-agenda-description/save-agenda-response/form";
import NonSubmitableAgenda from "../../organisms/project/project-agenda/project-agenda-description/save-agenda-response/NonSubmitableAgenda";
import { TCategorizedAgenda, TConfiguredAgendaItem } from "../../organisms/accept-invitation-form/type";

interface AgendaDetailsProps {
  agenda: TConfiguredAgendaItem;
  showArchived: boolean;
  peId: number;
  expertId: number;
  projectId: number;
  setPeAgendaData: React.Dispatch<React.SetStateAction<TCategorizedAgenda>>;
  handleNoSentAgendaExist: () => void;
  isAcceptInvitation: boolean;
  showRevokeBtn?: boolean;
}
const AgendaDetails: React.FC<AgendaDetailsProps> = ({
  agenda,
  showArchived,
  peId,
  expertId,
  projectId,
  setPeAgendaData,
  handleNoSentAgendaExist,
  isAcceptInvitation,
  showRevokeBtn = false
}) => (
  <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', px: 2, pb: 2 }}>
    {!showArchived ? (
      <SaveAgendaResponseForm
        setPeAgendaData={setPeAgendaData}
        pe_agenda={agenda}
        pe_id={peId}
        agenda_id={agenda?.fk_agenda}
        expertId={expertId}
        pe_agenda_id={agenda?.id}
        project_id={projectId}
        handleSubmitClose={() => {}}
        isAcceptInvitation={isAcceptInvitation}
        handleNoSentAgendaExist={handleNoSentAgendaExist}
        showRevokeBtn={showRevokeBtn}
      />
    ) : (
      <NonSubmitableAgenda pe_agenda={agenda} />
    )}
  </Box>
);

export default AgendaDetails;